import { PaymentMethod } from '@bybeam/platform-types';
import { Step } from '@platform-ui-common/hooks/useProgress/useProgress.js';
import ClaimRoutes from '@platform-ui/claim/ClaimRoutes.js';

export const INTRO_STEPS: Step[] = [
  {
    displayName: 'Payment Method',
    key: 'payment-method',
    route: ClaimRoutes.PAYMENT_METHOD,
  },
  {
    displayName: 'How It Works',
    key: 'how-it-works',
    route: ClaimRoutes.PRIMER,
  },
];

const REVIEW_STEP: Step = {
  displayName: 'Review',
  key: 'review',
  route: ClaimRoutes.REVIEW,
};

const MAILING_ADDRESS_STEPS: Step[] = [
  {
    displayName: 'Mailing Address',
    key: 'mailing-address',
    route: ClaimRoutes.MAILING_ADDRESS,
  },
  REVIEW_STEP,
];

export const TAX_FORM_STEPS: Step[] = [
  {
    displayName: 'Tax Form',
    key: 'tax-form',
    route: ClaimRoutes.W9_TAX_FORM,
  },
];

export const CLAIM_STEPS: Record<Exclude<PaymentMethod, PaymentMethod.External>, Step[]> = {
  [PaymentMethod.DirectDeposit]: [
    {
      displayName: 'Routing Number',
      key: 'routing-number',
      route: ClaimRoutes.ACH_ROUTING_NUMBER,
    },
    {
      displayName: 'Account Type',
      key: 'account-type',
      route: ClaimRoutes.ACH_ACCOUNT_TYPE,
    },
    {
      displayName: 'Account Number',
      key: 'account-number',
      route: ClaimRoutes.ACH_ACCOUNT_NUMBER,
    },
    REVIEW_STEP,
  ],
  [PaymentMethod.Check]: MAILING_ADDRESS_STEPS,
  [PaymentMethod.PhysicalCard]: MAILING_ADDRESS_STEPS,
  [PaymentMethod.VirtualCard]: MAILING_ADDRESS_STEPS,
  [PaymentMethod.Zelle]: [
    {
      displayName: 'How To Link Zelle',
      key: 'zelle-primer',
      route: ClaimRoutes.ZELLE_PRIMER,
    },
    {
      displayName: 'Zelle Email Confirmation',
      key: 'email-confirmation',
      route: ClaimRoutes.ZELLE_EMAIL_CONFIRMATION,
    },
  ],
};

export default CLAIM_STEPS;
